import React from "react";
import { SiteCenterBox } from "../../front/SiteCenterBox";
import { SiteLayout } from "../../front/SiteLayout";
import { WarningIcon } from "../../graphic/WarningIcon";

/**
 * Full-window error page (not found, no access, …) in the public site style, always with the warning icon.
 * Covers the app layout, so it can be rendered from anywhere.
 * @param children – action buttons; one fills the row, several share it evenly
 */
export const ErrorScreen = ({ eyebrow, title, message, children }) => {
    return (
        <SiteLayout fullscreen>
            <SiteCenterBox
                graphic={<WarningIcon />}
                eyebrow={eyebrow}
                title={title}
                subtitle={message}
                actions={children}
            />
        </SiteLayout>
    );
};
